import React from "react";
import "./css/index.css";
import { useNavigate } from "react-router-dom";

export const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="footer">
      <div className="footer-content">
        <h2 className="footer-title">
          Create Colorful Projects Instantly
        </h2>

        <p className="footer-subtitle">
          Use our Randomizer Palette to discover bold, beautiful color
          combinations for your next design.
        </p>

        <button onClick={() => navigate("/")} className="footer-btn">
          Generate New Palette →
        </button>

        <p className="footer-hint">
          Press spacebar to remix your colors anytime
        </p>
      </div>

      {/* Bottom Section */}
      <div className="footer-bottom">
   

        <p className="copyright">
          © 2026 World Paint. All rights reserved.
        </p>
      </div>
    </footer>
  );
};